function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zm0 2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.49 19.105a1 1 0 011.341.45A8 8 0 0016 24a8 8 0 007.169-4.445 1 1 0 111.791.89A10 10 0 0116 26a10 10 0 01-8.96-5.555 1 1 0 01.45-1.34zM11 12c-.896 0-1.7.391-2.25 1.016a1 1 0 11-1.5-1.324A4.99 4.99 0 0111 10a4.99 4.99 0 013.75 1.692 1 1 0 11-1.5 1.324A2.99 2.99 0 0011 12zM21 12c-.896 0-1.7.391-2.25 1.016a1 1 0 11-1.5-1.324A4.99 4.99 0 0121 10a4.99 4.99 0 013.75 1.692 1 1 0 11-1.5 1.324A2.99 2.99 0 0021 12z",
  fill: "currentColor"
})));